// extracted by mini-css-extract-plugin
export default {"root":"AdjustmentSuggestion_root__mjJAZ","buttonText":"AdjustmentSuggestion_buttonText__gMJtH"};